import React from 'react';
import styles from './Spinner.module.css';

const Overlay = (props) => {
  return (
    <div
      className={
        props.className
          ? `${styles.overlay} ${props.className}`
          : `${styles.overlay}`
      }
    >
      {props.children}
    </div>
  );
};

export default Overlay;
